/**
 * Ultimate Shopify DataLayer - External Refactored Engine
 */
(function() {
  class Ultimate_Shopify_DataLayer {
    constructor() {
      window.dataLayer = window.dataLayer || []; 
      
      this.dlData = window.ShopifyDLData || {};
      this.eventPrefix = '';
      this.formattedItemId = true; 

      this.dataSchema = {
        ecommerce: { show: true },
        dynamicRemarketing: { show: false, business_vertical: 'retail' }
      };

      this.addToWishListSelectors = {
        'addWishListIcon': '',
        'gridItemSelector': '',
        'productLinkSelector': 'a[href*="/products/"]'
      };

      this.quickViewSelector = {
        'quickViewElement': '',
        'gridItemSelector': '',
        'productLinkSelector': 'a[href*="/products/"]'
      };

      this.miniCartButton = ['a[href="/cart"]'];
      this.miniCartAppersOn = 'click';

      this.beginCheckoutButtons = [
        'input[name="checkout"]',
        'button[name="checkout"]',
        'a[href="/checkout"]',
        '.additional-checkout-buttons'
      ];

      this.shopifyDirectCheckoutButton = ['.shopify-payment-button'];
      this.isAddToCartRedirect = false;
      this.isAjaxCartIncrementDecrement = true;

      // 動態讀取全域變數
      this.cart = this.dlData.cart || {};
      this.countryCode = this.dlData.countryCode || '';
      this.storeURL = this.dlData.storeURL || '';
      if (this.countryCode) {
        localStorage.setItem('shopCountryCode', this.countryCode);
      }
      
      this.itemsList = [];
      this.collectData(); 
    }

    updateCart() {
      fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        this.cart = data;
      });
    }

    debounce(delay) {         
      let timeoutId;
      return function(func) {
        const context = this;
        const args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
          func.apply(context, args);
        }, delay);
      };
    }

    eventConsole(eventName, eventData) {
      const css1 = 'background: red; color: #fff; font-size: normal; border-radius: 3px 0 0 3px; padding: 3px 4px;';
      const css2 = 'background-color: blue; color: #fff; font-size: normal; border-radius: 0 3px 3px 0; padding: 3px 4px;';
      console.log('%cGTM DataLayer Event:%c' + eventName, css1, css2, eventData);
    }

    collectData() { 
      this.customerData();
      this.ajaxRequestData();
      this.searchPageData();
      this.miniCartData();
      this.beginCheckoutData();

      const template = this.dlData.template || '';
      if (template.includes('cart')) {
        this.viewCartPageData();
      }
      if (template.includes('product')) {
        this.productSinglePage();
      }
      if (template.includes('collection')) {
        this.collectionsPageData();
      }

      this.addToWishListData();
      this.quickViewData();
      this.selectItemData(); 
      this.formData();
      this.phoneClickData();
      this.emailClickData();
      this.loginRegisterData();
    }        

    customerData() {
      const currentUser = this.dlData.customer || {};
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ customer: currentUser });
    }

    ajaxRequestData() {
      const self = this;
      if(this.isAddToCartRedirect) {
        document.addEventListener('submit', function(event) {
          const addToCartForm = event.target.closest('form[action="/cart/add"]');
          if(addToCartForm) {
            event.preventDefault();
            const formData = new FormData(addToCartForm);
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              body: formData
            })
            .then(response => {
                window.location.href = self.dlData.cartUrl || "/cart";
            })
            .catch((error) => console.error('Error:', error));
          }
        });
      }
      
      let originalFetch = window.fetch;
      let debounce = this.debounce(800);
      
      window.fetch = function () {
        return originalFetch.apply(this, arguments).then((response) => {
          if (response.ok) {
            let cloneResponse = response.clone();
            let requestURL = arguments[0]['url'] || arguments[0];
            
            if(typeof requestURL === 'string' && /.*\/search\/?.*\?.*q=.+/.test(requestURL) && !requestURL.includes('&requestFrom=uldt')) {   
              const queryString = requestURL.split('?')[1];
              const urlParams = new URLSearchParams(queryString);
              const search_term = urlParams.get("q");

              debounce(function() {
                fetch(`${self.storeURL}/search/suggest.json?q=${search_term}&resources[type]=product&requestFrom=uldt`)
                  .then(res => res.json())
                  .then(function(data) {
                    const products = data.resources.results.products;
                    if(products.length) {
                      const fetchRequests = products.map(product =>
                        fetch(`${self.storeURL}/${product.url.split('?')[0]}.js`)
                          .then(response => response.json())
                          .catch(error => console.error('Error fetching:', error))
                      );

                      Promise.all(fetchRequests)
                        .then(products => {
                          const items = products.map((product) => ({
                            product_id: product.id,
                            product_title: product.title,
                            variant_id: product.variants[0].id,
                            variant_title: product.variants[0].title,
                            vendor: product.vendor,
                            total_discount: 0,
                            final_price: product.price_min,
                            product_type: product.type, 
                            quantity: 1
                          }));
                          self.ecommerceDataLayer('search', {search_term, items});
                        });
                    } else {
                      self.ecommerceDataLayer('search', {search_term, items: []});
                    }
                  });
              });
            }
            else if (typeof requestURL === 'string' && requestURL.includes("/cart/add")) {
              cloneResponse.text().then((text) => {
                let data = JSON.parse(text);
                if(data.items && Array.isArray(data.items)) {
                  data.items.forEach(item => self.ecommerceDataLayer('add_to_cart', {items: [item]}));
                } else {
                  self.ecommerceDataLayer('add_to_cart', {items: [data]});
                }
                self.updateCart();
              });
            } else if(typeof requestURL === 'string' && (requestURL.includes("/cart/change") || requestURL.includes("/cart/update"))) {
              cloneResponse.text().then((text) => {
                let newCart = JSON.parse(text);
                let newCartItems = newCart.items;
                let oldCartItems = self.cart.items || [];

                for(let i = 0; i < oldCartItems.length; i++) {
                  let item = oldCartItems[i];
                  let newItem = newCartItems.find(newItems => newItems.id === item.id);
                  if(newItem) {
                    if(newItem.quantity > item.quantity) {
                      let quantity = (newItem.quantity - item.quantity);
                      self.ecommerceDataLayer('add_to_cart', {items: [{...item, quantity}]});
                      self.updateCart(); 
                    } else if(newItem.quantity < item.quantity) {
                      let quantity = (item.quantity - newItem.quantity);
                      self.ecommerceDataLayer('remove_from_cart', {items: [{...item, quantity}]});
                      self.updateCart(); 
                    }
                  } else {
                    self.ecommerceDataLayer('remove_from_cart', {items: [item]});
                    self.updateCart(); 
                  }
                }
              });
            }
          }
          return response;
        });
      };

      var origXMLHttpRequest = XMLHttpRequest;
      XMLHttpRequest = function() {
        var requestURL;
        var xhr = new origXMLHttpRequest();
        var origOpen = xhr.open;
        var origSend = xhr.send;
        
        xhr.open = function(method, url) {
          requestURL = url;
          return origOpen.apply(this, arguments);
        };

        xhr.send = function() {
          if (typeof requestURL === 'string' && (requestURL.includes("/cart/add") || requestURL.includes("/cart/change") || /.*\/search\/?.*\?.*q=.+/.test(requestURL))) {
            xhr.addEventListener('load', function() {
              if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 400) { 
                if(/.*\/search\/?.*\?.*q=.+/.test(requestURL) && !requestURL.includes('&requestFrom=uldt')) {
                  const queryString = requestURL.split('?')[1];
                  const urlParams = new URLSearchParams(queryString);
                  const search_term = urlParams.get("q");

                  debounce(function() {
                    fetch(`${self.storeURL}/search/suggest.json?q=${search_term}&resources[type]=product&requestFrom=uldt`)
                      .then(res => res.json())
                      .then(function(data) {
                        const products = data.resources.results.products;
                        if(products.length) {
                          const fetchRequests = products.map(product =>
                            fetch(`${self.storeURL}/${product.url.split('?')[0]}.js`)
                              .then(response => response.json())
                              .catch(error => console.error('Error fetching:', error))
                          );

                          Promise.all(fetchRequests).then(products => {
                            const items = products.map(product => ({
                              product_id: product.id,
                              product_title: product.title,
                              variant_id: product.variants[0].id,
                              variant_title: product.variants[0].title,
                              vendor: product.vendor,
                              total_discount: 0,
                              final_price: product.price_min,
                              product_type: product.type, 
                              quantity: 1
                            }));
                            self.ecommerceDataLayer('search', {search_term, items});
                          });
                        } else {
                          self.ecommerceDataLayer('search', {search_term, items: []});
                        }
                      });
                  });
                } else if(requestURL.includes("/cart/add")) {
                  const data = JSON.parse(xhr.responseText);
                  if(data.items && Array.isArray(data.items)) {
                    data.items.forEach(item => self.ecommerceDataLayer('add_to_cart', {items: [item]}));
                  } else {
                    self.ecommerceDataLayer('add_to_cart', {items: [data]});
                  }
                  self.updateCart();
                } else if(requestURL.includes("/cart/change")) {
                  const newCart = JSON.parse(xhr.responseText);
                  const newCartItems = newCart.items;
                  let oldCartItems = self.cart.items || [];

                  for(let i = 0; i < oldCartItems.length; i++) {
                    let item = oldCartItems[i];
                    let newItem = newCartItems.find(newItems => newItems.id === item.id);
                    if(newItem) {
                      if(newItem.quantity > item.quantity) {
                        let quantity = (newItem.quantity - item.quantity);
                        self.ecommerceDataLayer('add_to_cart', {items: [{...item, quantity}]});
                        self.updateCart(); 
                      } else if(newItem.quantity < item.quantity) {
                        let quantity = (item.quantity - newItem.quantity);
                        self.ecommerceDataLayer('remove_from_cart', {items: [{...item, quantity}]});
                        self.updateCart(); 
                      }
                    } else {
                      self.ecommerceDataLayer('remove_from_cart', {items: [item]});
                      self.updateCart(); 
                    }
                  }
                }          
              }
            });
          }
          return origSend.apply(this, arguments);
        };
        return xhr;
      }; 
    }

    searchPageData() {
      const self = this;
      let pageUrl = window.location.href;
      if(/.+\/search\?.*\&?q=.+/.test(pageUrl)) {   
        const queryString = pageUrl.split('?')[1];
        const urlParams = new URLSearchParams(queryString);
        const search_term = urlParams.get("q");
            
        fetch(`${this.storeURL}/search/suggest.json?q=${search_term}&resources[type]=product&requestFrom=uldt`)
        .then(res => res.json())
        .then(function(data) {
          const products = data.resources.results.products;
          if(products.length) {
            const fetchRequests = products.map(product =>
              fetch(`${self.storeURL}/${product.url.split('?')[0]}.js`)
                .then(response => response.json())
                .catch(error => console.error('Error fetching:', error))
            );
            Promise.all(fetchRequests).then(products => {
              const items = products.map(product => ({
                product_id: product.id,
                product_title: product.title,
                variant_id: product.variants[0].id,
                variant_title: product.variants[0].title,
                vendor: product.vendor,
                total_discount: 0,
                final_price: product.price_min,
                product_type: product.type, 
                quantity: 1
              }));
              self.ecommerceDataLayer('search', {search_term, items});
            });
          } else {
            self.ecommerceDataLayer('search', {search_term, items: []});
          }
        });
      }
    }

    miniCartData() {
      if(this.miniCartButton.length) {
        let self = this;
        let eventType = this.miniCartAppersOn === 'hover' ? 'mouseenter' : this.miniCartAppersOn;
        this.miniCartButton.forEach((selector) => {
          let miniCartButtons = document.querySelectorAll(selector);
          miniCartButtons.forEach((miniCartButton) => {
            miniCartButton.addEventListener(eventType, () => {
              self.ecommerceDataLayer('view_cart', self.cart);
            });
          });
        });
      }
    }

    beginCheckoutData() {
      let self = this;
      document.addEventListener('pointerdown', (event) => {
        let targetElement = event.target.closest(self.beginCheckoutButtons.join(', '));
        if(targetElement) {
          self.ecommerceDataLayer('begin_checkout', self.cart);
        }
      });
    }

    viewCartPageData() {
      this.ecommerceDataLayer('view_cart', this.cart);
      if(!this.isAjaxCartIncrementDecrement) {
        const self = this;
        document.addEventListener('pointerdown', (event) => {
          const target = event.target.closest('a[href*="/cart/change?"]');
          if(target) {
            const linkUrl = target.getAttribute('href');
            const queryString = linkUrl.split("?")[1];
            const urlParams = new URLSearchParams(queryString);
            const newQuantity = urlParams.get("quantity");
            const line = urlParams.get("line");
            const cart_id = urlParams.get("id");
            
            if(newQuantity && (line || cart_id)) {
              let item = line ? {...self.cart.items[line - 1]} : self.cart.items.find(item => item.key === cart_id);
              let event = newQuantity < item.quantity ? 'remove_from_cart' : 'add_to_cart';
              let quantity = Math.abs(newQuantity - item.quantity);
              item['quantity'] = quantity;
              self.ecommerceDataLayer(event, {items: [item]});
            }
          }
        });
      }
    }

    productSinglePage() {
      if (!this.dlData.product) return;
      const prod = this.dlData.product;
      const item = {
        product_id: prod.id,
        variant_id: prod.selected_variant_id,
        product_title: prod.title,
        line_level_total_discount: 0,
        vendor: prod.vendor,
        sku: prod.sku,
        product_type: prod.type,
        item_list_id: prod.collection_id,
        item_list_name: prod.collection_title,
        variant_title: prod.variant_title !== "Default Title" ? prod.variant_title : undefined,
        final_price: prod.price,
        quantity: 1
      };
      
      const variants = prod.variants || [];
      this.ecommerceDataLayer('view_item', {items: [item]});

      if(this.shopifyDirectCheckoutButton.length) {
        let self = this;
        document.addEventListener('pointerdown', (event) => {  
          let checkoutButton = event.target.closest(this.shopifyDirectCheckoutButton.join(', '));
          if(checkoutButton && (variants || self.quickViewVariants)) {
            let checkoutForm = checkoutButton.closest('form[action*="/cart/add"]');
            if(checkoutForm) {
              let variant_id = null;
              let varientInput = checkoutForm.querySelector('input[name="id"]');
              let varientIdFromURL = new URLSearchParams(window.location.search).get('variant');
              let firstVarientId = item.variant_id;

              if(varientInput) variant_id = parseInt(varientInput.value);
              else if(varientIdFromURL) variant_id = varientIdFromURL;
              else if(firstVarientId) variant_id = firstVarientId;

              if(variant_id) {
                variant_id = parseInt(variant_id);
                let quantity = 1;
                let quantitySelector = checkoutForm.getAttribute('id');
                if(quantitySelector) {
                  let quentityInput = document.querySelector('input[name="quantity"][form="'+quantitySelector+'"]');
                  if(quentityInput) quantity = +quentityInput.value;
                }
              
                let variant = variants.find(item => item.id === +variant_id);
                if(variant && item) {
                  item['variant_id'] = variant_id;
                  item['variant_title'] = variant.title;
                  item['final_price'] = variant.price;
                  item['quantity'] = quantity;
                  
                  self.ecommerceDataLayer('add_to_cart', {items: [item]});
                  self.ecommerceDataLayer('begin_checkout', {items: [item]});
                } else if(self.quickViewedItem) {                                  
                  let variant = self.quickViewVariants.find(item => item.id === +variant_id);
                  if(variant) {
                    self.quickViewedItem['variant_id'] = variant_id;
                    self.quickViewedItem['variant_title'] = variant.title;
                    self.quickViewedItem['final_price'] = parseFloat(variant.price) * 100;
                    self.quickViewedItem['quantity'] = quantity;
                    
                    self.ecommerceDataLayer('add_to_cart', {items: [self.quickViewedItem]});
                    self.ecommerceDataLayer('begin_checkout', {items: [self.quickViewedItem]});
                  }
                }
              }
            }
          }
        }); 
      }
    }

    collectionsPageData() {
      if (!this.dlData.collection) return;
      const col = this.dlData.collection;
      var ecommerce = {
        'items': col.products || []
      };

      this.itemsList = ecommerce.items;
      ecommerce['item_list_id'] = col.id;
      ecommerce['item_list_name'] = col.title;

      this.ecommerceDataLayer('view_item_list', ecommerce);
    }
    
    addToWishListData() {
      if(this.addToWishListSelectors && this.addToWishListSelectors.addWishListIcon) {
        const self = this;
        document.addEventListener('pointerdown', (event) => {
          let target = event.target;
          if(target.closest(self.addToWishListSelectors.addWishListIcon)) {
            let pageULR = window.location.href.replace(/\?.+/, '');
            let requestURL = undefined;

            if(/\/products\/[^/]+$/.test(pageULR)) {
              requestURL = pageULR;
            } else if(self.addToWishListSelectors.gridItemSelector && self.addToWishListSelectors.productLinkSelector) {
              let itemElement = target.closest(self.addToWishListSelectors.gridItemSelector);
              if(itemElement) {
                let linkElement = itemElement.querySelector(self.addToWishListSelectors.productLinkSelector); 
                if(linkElement) {
                  let link = linkElement.getAttribute('href').replace(/\?.+/g, '');
                  if(link && /\/products\/[^/]+$/.test(link)) requestURL = link;
                }
              }
            }

            if(requestURL) {
              fetch(requestURL + '.json')
                .then(res => res.json())
                .then(result => {
                  let data = result.product;                    
                  if(data) {
                    let dataLayerData = {
                      product_id: data.id,
                      variant_id: data.variants[0].id,
                      product_title: data.title,
                      quantity: 1,
                      final_price: parseFloat(data.variants[0].price) * 100,
                      total_discount: 0,
                      product_type: data.product_type,
                      vendor: data.vendor,
                      variant_title: (data.variants[0].title !== 'Default Title') ? data.variants[0].title : undefined,
                      sku: data.variants[0].sku,
                    };
                    self.ecommerceDataLayer('add_to_wishlist', {items: [dataLayerData]});
                  }
                });
            }
          }
        });
      }
    }

    quickViewData() {
      if(this.quickViewSelector.quickViewElement && this.quickViewSelector.gridItemSelector && this.quickViewSelector.productLinkSelector) {
        const self = this;
        document.addEventListener('pointerdown', (event) => {
          let target = event.target;
          if(target.closest(self.quickViewSelector.quickViewElement)) {
            let requestURL = undefined;
            let itemElement = target.closest(this.quickViewSelector.gridItemSelector );
            if(itemElement) {
              let linkElement = itemElement.querySelector(self.quickViewSelector.productLinkSelector); 
              if(linkElement) {
                let link = linkElement.getAttribute('href').replace(/\?.+/g, '');
                if(link && /\/products\/[^/]+$/.test(link)) requestURL = link;
              }
            }   
            if(requestURL) {
              fetch(requestURL + '.json')
                .then(res => res.json())
                .then(result => {
                  let data = result.product;                    
                  if(data) {
                    let dataLayerData = {
                      product_id: data.id,
                      variant_id: data.variants[0].id,
                      product_title: data.title,
                      quantity: 1,
                      final_price: parseFloat(data.variants[0].price) * 100,
                      total_discount: 0,
                      product_type: data.product_type,
                      vendor: data.vendor,
                      variant_title: (data.variants[0].title !== 'Default Title') ? data.variants[0].title : undefined,
                      sku: data.variants[0].sku,
                    };
                    self.ecommerceDataLayer('view_item', {items: [dataLayerData]});
                    self.quickViewVariants = data.variants;
                    self.quickViewedItem = dataLayerData;
                  }
                });
            }
          }
        });

        const template = this.dlData.template || '';
        if(!template.includes('product')) {
          if(this.shopifyDirectCheckoutButton.length) {
            let self = this;
            document.addEventListener('pointerdown', (event) => {
              let checkoutButton = event.target.closest(this.shopifyDirectCheckoutButton.join(', '));
              if(self.quickViewVariants && self.quickViewedItem && self.quickViewVariants.length && checkoutButton) {
                let checkoutForm = checkoutButton.closest('form[action*="/cart/add"]');
                if(checkoutForm) {
                  let quantity = 1;
                  let varientInput = checkoutForm.querySelector('input[name="id"]');
                  let quantitySelector = checkoutForm.getAttribute('id');

                  if(quantitySelector) {
                    let quentityInput = document.querySelector('input[name="quantity"][form="'+quantitySelector+'"]');
                    if(quentityInput) quantity = +quentityInput.value;
                  }

                  if(varientInput) {
                    let variant_id = parseInt(varientInput.value);
                    if(variant_id) {
                      const variant = self.quickViewVariants.find(item => item.id === +variant_id);
                      if(variant && self.quickViewedItem) {
                        self.quickViewedItem['variant_id'] = variant_id;
                        self.quickViewedItem['variant_title'] = variant.title;
                        self.quickViewedItem['final_price'] = parseFloat(variant.price) * 100;
                        self.quickViewedItem['quantity'] = quantity; 

                        self.ecommerceDataLayer('add_to_cart', {items: [self.quickViewedItem]});
                        self.ecommerceDataLayer('begin_checkout', {items: [self.quickViewedItem]});
                      }
                    }
                  }
                }
              }
            }); 
          }
        }
      }
    }

    selectItemData() {
      const self = this;
      const items = this.itemsList;
      const template = this.dlData.template || '';

      if (template.includes('collection')) {            
        document.addEventListener('pointerdown', function(event) {
          const productLink = event.target.closest('a[href*="/products/"]');
          if(productLink) {
            const linkUrl = productLink.getAttribute('href');
            const matchProduct = (item) => {
              var itemSlug = (item.url.split('/products/')[1]).split('#')[0].split('?')[0].trim();
              var linkUrlItemSlug = (linkUrl.split('/products/')[1]).split('#')[0].split('?')[0].trim();
              return itemSlug === linkUrlItemSlug;  
            };
            const item = items.find(matchProduct);
            const index = items.findIndex(matchProduct);
            if(item) {
              self.ecommerceDataLayer('select_item', {items: [{...item, index: index}]});
            }
          }
        });
      }

      document.addEventListener('variant:change', function(event) {            
        const product_id = event.detail.product.id;
        const variant_id = event.detail.variant.id;
        const vendor = event.detail.product.vendor; 
        const variant_title = event.detail.variant.public_title;
        const product_title = event.detail.product.title;
        const final_price = event.detail.variant.price;
        const product_type = event.detail.product.type;

        const item = {
          product_id: product_id,
          product_title: product_title,
          variant_id: variant_id,
          variant_title: variant_title,
          vendor: vendor,
          final_price: final_price,
          product_type: product_type, 
          quantity: 1
        };
        self.ecommerceDataLayer('select_item', {items: [item]});
      });
    }

    ecommerceDataLayer(event, data) {
      const self = this;
      dataLayer.push({ 'ecommerce': null });
      const dataLayerData = {
        "event": this.eventPrefix + event,
        'ecommerce': {
          'currency': this.cart.currency,
          'items': data.items.map((item, index) => {
            const dataLayerItem = {
              'index': index,
              'item_id': this.formattedItemId ? `shopify_${this.countryCode}_${item.product_id}_${item.variant_id}` : item.product_id.toString(),
              'product_id': item.product_id.toString(),
              'variant_id': item.variant_id.toString(),
              'item_name': item.product_title,
              'quantity': item.quantity,
              'price': +((item.final_price / 100).toFixed(2)),
              'discount': item.total_discount ? +((item.total_discount / 100).toFixed(2)) : 0 
            };

            if(item.product_type) dataLayerItem['item_category'] = item.product_type;
            if(item.vendor) dataLayerItem['item_brand'] = item.vendor;
            if(item.variant_title && item.variant_title !== 'Default Title') dataLayerItem['item_variant'] = item.variant_title;
            if(item.sku) dataLayerItem['sku'] = item.sku;
            if(item.item_list_name) dataLayerItem['item_list_name'] = item.item_list_name;
            if(item.item_list_id) dataLayerItem['item_list_id'] = item.item_list_id.toString();

            return dataLayerItem;
          })
        }
      };

      if(data.total_price !== undefined) {
        dataLayerData['ecommerce']['value'] = +((data.total_price / 100).toFixed(2));
      } else {
        dataLayerData['ecommerce']['value'] = +(dataLayerData['ecommerce']['items'].reduce((total, item) => total + (item.price * item.quantity), 0)).toFixed(2);
      }
      
      if(data.item_list_id) dataLayerData['ecommerce']['item_list_id'] = data.item_list_id;
      if(data.item_list_name) dataLayerData['ecommerce']['item_list_name'] = data.item_list_name;
      if(data.search_term) dataLayerData['search_term'] = data.search_term;

      if(self.dataSchema.dynamicRemarketing && self.dataSchema.dynamicRemarketing.show) {
        dataLayer.push({ 'dynamicRemarketing': null });
        dataLayerData['dynamicRemarketing'] = {
          value: dataLayerData.ecommerce.value,
          items: dataLayerData.ecommerce.items.map(item => ({id: item.item_id, google_business_vertical: self.dataSchema.dynamicRemarketing.business_vertical}))
        };
      }

      if(!self.dataSchema.ecommerce || !self.dataSchema.ecommerce.show) {
        delete dataLayerData['ecommerce'];
      }

      dataLayer.push(dataLayerData);
      self.eventConsole(self.eventPrefix + event, dataLayerData);
    }

    formData() {
      const self = this;
      document.addEventListener('submit', function(event) {
        let targetForm = event.target.closest('form[action^="/contact"]');
        if(targetForm) {
          const formData = {
            form_location: window.location.href,
            form_id: targetForm.getAttribute('id'),
            form_classes: targetForm.getAttribute('class')
          };
                        
          let formType = targetForm.querySelector('input[name="form_type"]');
          let inputs = targetForm.querySelectorAll("input:not([type=hidden]):not([type=submit]), textarea, select");
          
          inputs.forEach(function(input) {
            var inputName = input.name;
            var inputValue = input.value;
            if (inputName && inputValue) {
              var matches = inputName.match(/\[(.*?)\]/);
              if (matches && matches.length > 1) {
                var fieldName = matches[1];
                formData[fieldName] = input.value;
              }
            }
          });
          
          if(formType && formType.value === 'customer') {
            dataLayer.push({ event: self.eventPrefix + 'newsletter_signup', ...formData});
            self.eventConsole(self.eventPrefix + 'newsletter_signup', { event: self.eventPrefix + 'newsletter_signup', ...formData});
          } else if(formType && formType.value === 'contact') {
            dataLayer.push({ event: self.eventPrefix + 'contact_form_submit', ...formData});
            self.eventConsole(self.eventPrefix + 'contact_form_submit', { event: self.eventPrefix + 'contact_form_submit', ...formData});
          }
        }
      });
    }

    phoneClickData() {
      const self = this; 
      document.addEventListener('click', function(event) {
        let target = event.target.closest('a[href^="tel:"]');
        if(target) {
          let phone_number = target.getAttribute('href').replace('tel:', '');
          let eventData = {
            event: self.eventPrefix + 'phone_number_click',
            page_location: window.location.href,
            link_classes: target.getAttribute('class'),
            link_id: target.getAttribute('id'),
            phone_number
          };
          dataLayer.push(eventData);
          self.eventConsole(self.eventPrefix + 'phone_number_click', eventData);
        }
      });
    }

    emailClickData() {
      const self = this; 
      document.addEventListener('click', function(event) {
        let target = event.target.closest('a[href^="mailto:"]');
        if(target) {
          let email_address = target.getAttribute('href').replace('mailto:', '');
          let eventData = {
            event: self.eventPrefix + 'email_click',
            page_location: window.location.href,
            link_classes: target.getAttribute('class'),
            link_id: target.getAttribute('id'),
            email_address
          };
          dataLayer.push(eventData);
          self.eventConsole(self.eventPrefix + 'email_click', eventData);
        }
      });
    }

    loginRegisterData() {
      const self = this; 
      let isTrackedLogin = false;
      let isTrackedRegister = false;
      
      if(window.location.href.includes('/account/login')) {
        document.addEventListener('submit', function(e) {
          const loginForm = e.target.closest('[action="/account/login"]');
          if(loginForm && !isTrackedLogin) {
            const eventData = { event: self.eventPrefix + 'login' };
            isTrackedLogin = true;
            dataLayer.push(eventData);
            self.eventConsole(self.eventPrefix + 'login', eventData);
          }
        });
      }

      if(window.location.href.includes('/account/register')) {
        document.addEventListener('submit', function(e) {
          const registerForm = e.target.closest('[action="/account"]');
          if(registerForm && !isTrackedRegister) {
            const eventData = { event: self.eventPrefix + 'sign_up' };
            isTrackedRegister = true;
            dataLayer.push(eventData);
            self.eventConsole(self.eventPrefix + 'sign_up', eventData);
          }
        });
      }
    }
  } 

  document.addEventListener('DOMContentLoaded', function() {
    try{
      new Ultimate_Shopify_DataLayer();
    }catch(error) {
      console.log(error);
    }
  });
})();